module.exports = __webpack_public_path__ + "img/logo.dde221eb.png";